import { cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils'
import { useFormField } from '../../form/Form'

// eslint-disable-next-line react-refresh/only-export-components
export const inputVariants = cva(
  'file:text-foreground focus-visible:ring-ring focus-visible:ring-accent flex w-full rounded-md py-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    defaultVariants: {
      variant: 'default'
    },
    variants: {
      variant: {
        default: 'text-dark h-11 border border-border px-3.5 text-base shadow-input'
      }
    }
  }
)

type InputProps = {
  variant?: 'default'
} & React.ComponentProps<'input'>

const Input = ({ className, type, variant, ...props }: InputProps) => {
  const { error } = useFormField()

  return (
    <input
      className={cn(
        inputVariants({ variant }),
        'focus:border-primary focus:ring-primary',
        'placeholder:text-[#717680]',
        error ? 'ring-1 !ring-destructive' : '',
        className
      )}
      type={type}
      {...props}
    />
  )
}

export { Input }
